import { Route } from '@angular/router';
import { MainLayoutComponent } from './layout/app-layout/main-layout/main-layout.component';
import { AuthGuard } from '@core/guard/auth.guard';
import { AuthLayoutComponent } from './layout/app-layout/auth-layout/auth-layout.component';
import { Page404Component } from './authentication/page404/page404.component';
import { Role } from '@core';
import { MainComponent } from './admin/dashboard/main/main.component';
import { SsoCallbackComponent } from './authentication/sso-callback/sso-callback.component';

export const APP_ROUTE: Route[] = [
  {
    path: 'sso-callback',
    component: SsoCallbackComponent,

  },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    children: [
     {
        path: '',
        canActivate: [AuthGuard],
        data: {
          role: Role.All,
        },
        loadChildren: () =>
          import('./home/home.module').then((m) => m.HomeModule),
      }
    ],
  },
  {
    path: 'authentication',
    component: AuthLayoutComponent,
    loadChildren: () =>
      import('./authentication/auth.routes').then((m) => m.AUTH_ROUTE),
  },
 
  { path: '**', component: Page404Component },
];
